import React, { useState } from 'react';
import { ShoppingBag, User, Heart, Search, Menu, X, Plus, ArrowRight, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template15 = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeImage, setActiveImage] = useState(0);

    const collections = [
        { name: 'Linen Edit', tagline: 'Breathable Comfort', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=800&h=1000&fit=crop', count: '48 products' },
        { name: 'Cotton Essentials', tagline: 'Everyday Ease', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=800&h=1000&fit=crop', count: '62 products' },
        { name: 'Handwoven', tagline: 'Artisan Made', image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=800&h=1000&fit=crop', count: '35 products' },
    ];

    const products = [
        { name: 'Linen Midi Dress', price: 4200, color: 'Sand', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&h=650&fit=crop' },
        { name: 'Cotton Kurta Set', price: 3800, color: 'Ivory', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop' },
        { name: 'Relaxed Linen Pants', price: 2900, color: 'Taupe', image: 'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop' },
        { name: 'Handloom Cotton Saree', price: 6500, color: 'Natural', image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop' },
        { name: 'Oversized Linen Shirt', price: 2400, color: 'Oat', image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&h=650&fit=crop' },
        { name: 'Cotton Palazzo Set', price: 4100, color: 'Ecru', image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=500&h=650&fit=crop' },
        { name: 'Block Print Dupatta', price: 1800, color: 'Terracotta', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500&h=650&fit=crop' },
        { name: 'Khadi Tunic Dress', price: 3500, color: 'Sage', image: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop' },
    ];

    const heroImages = [
        { src: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=1400&h=900&fit=crop', title: 'The Linen Edit', subtitle: 'Effortless elegance for warmer days' },
        { src: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1400&h=900&fit=crop', title: 'Handwoven Stories', subtitle: 'Crafted with intention' },
        { src: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=1400&h=900&fit=crop', title: 'Cotton Comfort', subtitle: 'Simplicity refined' },
    ];

    const testimonials = [
        { text: 'The quality of linen is exceptional. Every piece feels like a luxury.', name: 'Ananya Rao', city: 'Bangalore' },
        { text: 'Finally, sustainable fashion that does not compromise on style.', name: 'Meera Iyer', city: 'Chennai' },
    ];

    return (
        <div className="w-full min-h-screen bg-stone-50 font-sans">
            {/* Announcement Bar */}
            <div className="bg-stone-800 text-stone-100 text-center py-2.5 text-xs tracking-widest">
                COMPLIMENTARY SHIPPING ON ORDERS ABOVE ₹2,500
            </div>

            {/* Header */}
            <header className="bg-white sticky top-0 z-50">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-6 lg:px-12 py-5">
                        {/* Mobile Menu Toggle */}
                        <button
                            className="lg:hidden"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {mobileMenuOpen ? <X className="w-5 h-5 text-stone-800" /> : <Menu className="w-5 h-5 text-stone-800" />}
                        </button>

                        {/* Desktop Navigation Left */}
                        <nav className="hidden lg:flex items-center gap-10">
                            <button onClick={() => navigate('/template15/shop')} className="text-xs tracking-widest text-stone-700 hover:text-stone-900 transition-colors">
                                SHOP
                            </button>
                            <button className="text-xs tracking-widest text-stone-700 hover:text-stone-900 transition-colors flex items-center gap-1">
                                COLLECTIONS <ChevronDown className="w-3 h-3" />
                            </button>
                            <button className="text-xs tracking-widest text-stone-700 hover:text-stone-900 transition-colors">
                                ABOUT
                            </button>
                        </nav>

                        {/* Logo */}
                        <h1
                            onClick={() => navigate('/template15')}
                            className="text-2xl lg:text-3xl font-light tracking-[0.3em] text-stone-800 cursor-pointer"
                        >
                            SAHARA
                        </h1>

                        {/* Icons Right */}
                        <div className="flex items-center gap-5">
                            <Search className="w-4 h-4 text-stone-700 cursor-pointer hover:text-stone-900 transition-colors" />
                            <Heart className="w-4 h-4 text-stone-700 cursor-pointer hover:text-stone-900 transition-colors hidden sm:block" />
                            <User className="w-4 h-4 text-stone-700 cursor-pointer hover:text-stone-900 transition-colors hidden sm:block" onClick={() => navigate('/template15/profile')} />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template15/cart')}>
                                <ShoppingBag className="w-4 h-4 text-stone-700 hover:text-stone-900 transition-colors" />
                                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-stone-800 text-white text-[10px] rounded-full flex items-center justify-center">0</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="lg:hidden bg-white border-t border-stone-100">
                        <nav className="px-6 py-8 space-y-6">
                            <button onClick={() => { navigate('/template15/shop'); setMobileMenuOpen(false); }} className="block text-sm tracking-widest text-stone-700">SHOP</button>
                            <button className="block text-sm tracking-widest text-stone-700">COLLECTIONS</button>
                            <button className="block text-sm tracking-widest text-stone-700">ABOUT</button>
                            <button onClick={() => { navigate('/template15/contact'); setMobileMenuOpen(false); }} className="block text-sm tracking-widest text-stone-700">CONTACT</button>
                        </nav>
                    </div>
                )}
            </header>

            {/* Hero Section - Full Width with Minimal Text */}
            <section className="relative h-[85vh] lg:h-[90vh]">
                <div className="absolute inset-0">
                    <img
                        src={heroImages[activeImage].src}
                        alt="Hero"
                        className="w-full h-full object-cover transition-opacity duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-stone-900/30"></div>
                </div>

                <div className="absolute inset-0 flex items-end justify-center pb-20 lg:pb-28">
                    <div className="text-center text-white">
                        <p className="text-xs tracking-[0.4em] mb-4 text-stone-200">{heroImages[activeImage].subtitle.toUpperCase()}</p>
                        <h2 className="text-4xl md:text-5xl lg:text-7xl font-extralight tracking-wide mb-8">
                            {heroImages[activeImage].title}
                        </h2>
                        <button
                            onClick={() => navigate('/template15/shop')}
                            className="group px-10 py-4 bg-white text-stone-800 text-xs tracking-widest hover:bg-stone-100 transition-colors inline-flex items-center gap-3"
                        >
                            SHOP NOW
                            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </div>

                {/* Hero Navigation Dots */}
                <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
                    {heroImages.map((_, idx) => (
                        <button
                            key={idx}
                            onClick={() => setActiveImage(idx)}
                            className={`w-2 h-2 rounded-full transition-all ${activeImage === idx ? 'bg-white w-8' : 'bg-white/50'}`}
                        />
                    ))}
                </div>
            </section>

            {/* Collections Grid - Clean 3-Column */}
            <section className="py-20 lg:py-28 bg-white">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="text-center mb-16">
                        <p className="text-xs tracking-[0.3em] text-stone-500 mb-3">CURATED</p>
                        <h2 className="text-3xl lg:text-4xl font-extralight tracking-wide text-stone-800">Collections</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                        {collections.map((collection, index) => (
                            <div key={index} className="group cursor-pointer">
                                <div className="relative aspect-[4/5] overflow-hidden mb-5">
                                    <img
                                        src={collection.image}
                                        alt={collection.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-500"></div>
                                </div>
                                <div className="text-center">
                                    <p className="text-[10px] tracking-[0.2em] text-stone-500 mb-1">{collection.tagline.toUpperCase()}</p>
                                    <h3 className="text-lg font-light text-stone-800 tracking-wide">{collection.name}</h3>
                                    <p className="text-xs text-stone-500 mt-1">{collection.count}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Featured Products - Minimal Grid */}
            <section className="py-20 lg:py-28 bg-stone-50">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="flex items-end justify-between mb-14">
                        <div>
                            <p className="text-xs tracking-[0.3em] text-stone-500 mb-3">NEW IN</p>
                            <h2 className="text-3xl lg:text-4xl font-extralight tracking-wide text-stone-800">Latest Arrivals</h2>
                        </div>
                        <button
                            onClick={() => navigate('/template15/shop')}
                            className="hidden md:flex items-center gap-2 text-xs tracking-widest text-stone-700 hover:text-stone-900 transition-colors"
                        >
                            VIEW ALL <ArrowRight className="w-3 h-3" />
                        </button>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                        {products.map((product, index) => (
                            <div key={index} className="group">
                                <div className="relative aspect-[3/4] overflow-hidden mb-4 bg-stone-100">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover group-hover:opacity-0 transition-opacity duration-500"
                                    />
                                    <img
                                        src={product.hoverImage}
                                        alt={product.name}
                                        className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                                    />

                                    {/* Quick Add */}
                                    <button className="absolute bottom-4 left-4 right-4 py-3 bg-white text-stone-800 text-xs tracking-widest opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 flex items-center justify-center gap-2">
                                        <Plus className="w-3 h-3" /> QUICK ADD
                                    </button>

                                    {/* Wishlist */}
                                    <button className="absolute top-4 right-4 w-8 h-8 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        <Heart className="w-4 h-4 text-stone-600" />
                                    </button>
                                </div>
                                <div className="text-center">
                                    <p className="text-[10px] tracking-wider text-stone-500 mb-1">{product.color.toUpperCase()}</p>
                                    <h3 className="text-sm font-normal text-stone-800 mb-1">{product.name}</h3>
                                    <p className="text-sm text-stone-600">₹{product.price.toLocaleString()}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12 md:hidden">
                        <button
                            onClick={() => navigate('/template15/shop')}
                            className="text-xs tracking-widest text-stone-700 border-b border-stone-400 pb-1"
                        >
                            VIEW ALL PRODUCTS
                        </button>
                    </div>
                </div>
            </section>

            {/* Split Feature Section */}
            <section className="bg-white">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div className="aspect-square lg:aspect-auto">
                        <img
                            src="https://images.unsplash.com/photo-1558171813-4c088753af8f?w=900&h=900&fit=crop"
                            alt="Sustainable Fashion"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="flex items-center justify-center py-16 lg:py-0 px-8 lg:px-20 bg-stone-100">
                        <div className="max-w-md">
                            <p className="text-xs tracking-[0.3em] text-stone-500 mb-4">OUR PHILOSOPHY</p>
                            <h2 className="text-3xl lg:text-4xl font-extralight text-stone-800 mb-6 leading-relaxed">
                                Conscious Comfort
                            </h2>
                            <p className="text-stone-600 leading-relaxed mb-8">
                                Every piece is crafted with intention. We partner with local artisans across India
                                to bring you clothing that respects both tradition and the environment.
                                Natural fabrics, timeless designs, lasting quality.
                            </p>
                            <button className="text-xs tracking-widest text-stone-800 border-b border-stone-800 pb-1 hover:text-stone-600 hover:border-stone-600 transition-colors">
                                DISCOVER OUR STORY
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Editorial Banner */}
            <section className="relative h-[70vh] lg:h-[80vh]">
                <img
                    src="https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1600&h=900&fit=crop"
                    alt="Editorial"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-stone-900/30"></div>
                <div className="absolute inset-0 flex items-center justify-center text-center">
                    <div className="max-w-2xl px-6">
                        <p className="text-xs tracking-[0.4em] text-stone-200 mb-4">THE SUMMER COLLECTION</p>
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extralight text-white tracking-wide mb-6">
                            Effortless Style
                        </h2>
                        <p className="text-stone-200 mb-8 max-w-md mx-auto">
                            Light, breathable fabrics designed for Indian summers
                        </p>
                        <button
                            onClick={() => navigate('/template15/shop')}
                            className="px-10 py-4 bg-white text-stone-800 text-xs tracking-widest hover:bg-stone-100 transition-colors"
                        >
                            EXPLORE
                        </button>
                    </div>
                </div>
            </section>

            {/* Testimonials - Minimal */}
            <section className="py-20 lg:py-28 bg-white">
                <div className="max-w-screen-xl mx-auto px-6 lg:px-12">
                    <div className="text-center mb-16">
                        <p className="text-xs tracking-[0.3em] text-stone-500 mb-3">TESTIMONIALS</p>
                        <h2 className="text-3xl lg:text-4xl font-extralight tracking-wide text-stone-800">What They Say</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
                        {testimonials.map((testimonial, index) => (
                            <div key={index} className="text-center">
                                <p className="text-xl lg:text-2xl font-extralight text-stone-700 leading-relaxed mb-6 italic">
                                    "{testimonial.text}"
                                </p>
                                <p className="text-xs tracking-widest text-stone-500">
                                    {testimonial.name.toUpperCase()} — {testimonial.city.toUpperCase()}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Newsletter - Clean */}
            <section className="py-20 lg:py-24 bg-stone-100">
                <div className="max-w-xl mx-auto px-6 text-center">
                    <p className="text-xs tracking-[0.3em] text-stone-500 mb-3">NEWSLETTER</p>
                    <h2 className="text-2xl lg:text-3xl font-extralight tracking-wide text-stone-800 mb-4">Stay Updated</h2>
                    <p className="text-stone-600 text-sm mb-8">
                        Subscribe for early access to new collections and exclusive offers.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <input
                            type="email"
                            placeholder="Your email address"
                            className="flex-1 px-5 py-4 bg-white border-0 text-stone-800 text-sm placeholder-stone-400 focus:outline-none focus:ring-1 focus:ring-stone-300"
                        />
                        <button className="px-8 py-4 bg-stone-800 text-white text-xs tracking-widest hover:bg-stone-700 transition-colors">
                            SUBSCRIBE
                        </button>
                    </div>
                    <p className="text-xs text-stone-500 mt-4">No spam. Unsubscribe anytime.</p>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-stone-800 text-white">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-10 lg:gap-16">
                        <div className="md:col-span-1">
                            <h3 className="text-xl font-light tracking-[0.2em] mb-6">SAHARA</h3>
                            <p className="text-stone-400 text-sm leading-relaxed">
                                Sustainable fashion crafted with care. Timeless pieces for the conscious wardrobe.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-6 text-stone-300">SHOP</h4>
                            <ul className="space-y-3 text-sm">
                                <li><span onClick={() => navigate('/template15/shop')} className="text-stone-400 hover:text-white cursor-pointer transition-colors">All Products</span></li>
                                <li><span className="text-stone-400 hover:text-white cursor-pointer transition-colors">New Arrivals</span></li>
                                <li><span className="text-stone-400 hover:text-white cursor-pointer transition-colors">Linen</span></li>
                                <li><span className="text-stone-400 hover:text-white cursor-pointer transition-colors">Cotton</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-6 text-stone-300">HELP</h4>
                            <ul className="space-y-3 text-sm">
                                <li><span onClick={() => navigate('/template15/contact')} className="text-stone-400 hover:text-white cursor-pointer transition-colors">Contact</span></li>
                                <li><span className="text-stone-400 hover:text-white cursor-pointer transition-colors">Shipping</span></li>
                                <li><span className="text-stone-400 hover:text-white cursor-pointer transition-colors">Returns</span></li>
                                <li><span onClick={() => navigate('/template15/orders')} className="text-stone-400 hover:text-white cursor-pointer transition-colors">Track Order</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-6 text-stone-300">CONNECT</h4>
                            <ul className="space-y-3 text-sm">
                                <li className="text-stone-400">hello@sahara.in</li>
                                <li className="text-stone-400">+91 80 4567 8901</li>
                                <li className="text-stone-400 mt-4">Mon - Sat: 10am - 7pm</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-stone-500 text-xs">© 2025 Sahara. All rights reserved.</p>
                        <div className="flex gap-8 text-xs text-stone-500">
                            <span className="hover:text-white cursor-pointer transition-colors">Privacy Policy</span>
                            <span className="hover:text-white cursor-pointer transition-colors">Terms of Service</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template15;
